/**
 * @generated SignedSource<<d6ae5338c019d70022ecb0ce90446bdd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type row_nativeIssueTable_RowInner_issue$data = {
  readonly id: string;
  readonly isHighlightedIssueRow: boolean | null | undefined;
  readonly issueId: string;
  readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_issue">;
  readonly " $fragmentType": "row_nativeIssueTable_RowInner_issue";
};
export type row_nativeIssueTable_RowInner_issue$key = {
  readonly " $data"?: row_nativeIssueTable_RowInner_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"row_nativeIssueTable_RowInner_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "row_nativeIssueTable_RowInner_issue",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "issueRow_nativeIssueTable_IssueRowWithFragments_issue"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "issueId"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isHighlightedIssueRow"
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "f1aa43f307d95f3f63f93f35d327aff6";

export default node;
